import { createFileRoute, notFound } from '@tanstack/react-router';
import { NotFound } from '../-components/not-found';

export const Route = createFileRoute('/old/$')({
	// `notFound()` thrown from a LOADER is what makes the HTML render answer 404 — see www/$.tsx for
	// why `setResponseStatus` cannot.
	loader: () => {
		throw notFound();
	},
	// The shared `NotFound` rather than TanStack's `DefaultGlobalNotFound`: that one renders no
	// `<title>` and no `robots`, which is what left the landing's 404s unidentifiable in GA4 and
	// indexable by a crawler that ignores the status.
	notFoundComponent: RouteComponent,
	component: RouteComponent,
});

function RouteComponent() {
	return <NotFound />;
}
